<pos-app-spinner [show]="loading"></pos-app-spinner>
<div>
  <div *ngIf="actionAddResource && !actionChangeResource && !actionRemoveResource && !changeDateAndTime">
    <form [formGroup]="addResourceFrom" (submit)="submitAddResourceFrom(true)">
      <div class="modal-header">
        <h4 class="modal-title">ADD RESOURCE WORKSHOP</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <div class="group-gap row mb-2">
            <div class="col-md-3">
              <label>SELECT RESOURCE TYPE</label>
              <select formControlName="resourceType" class="mb-2 pt-2 pb-2">
                <option [value]="1" class="p-1">EXISTING RESOURCE</option>
                <option [value]="2" class="p-1">EXISTING GENERIC RESOURCE</option>
                <option [value]="3" class="p-1">ADD NEW RESOURCE</option>
                <option [value]="4" class="p-1">ADD NEW GENERIC RESOURCE</option>
              </select>
            </div>
            <div class="col-md-3">
              <div><label>RESOURCE NAME</label></div>
              <input
                matInput
                class="p-1"
                formControlName="resourceName"
                [readonly]="!allowResourceTyping"
                placeholder="Type Resource Name"
                (focus)="isFocus($event)"
                (blur)="lostFocus($event)"
              />
            </div>
            <div>
              <table *ngIf="filteredResources?.length > 0 && showResourceSearchTable" class="border my-4 table table-striped shadow-lg">
                <thead>
                  <tr>
                    <th scope="col" class="text-uppercase">
                      <label> Name</label>
                    </th>
                    <th scope="col" class="text-uppercase">
                      <label> Department</label>
                    </th>
                    <th scope="col" class="text-uppercase">
                      <label> Branch</label>
                    </th>
                    <th scope="col" class="text-uppercase">
                      <label> Description</label>
                    </th>
                    <th scope="col" class="text-uppercase">
                      <label> Resource Dec</label>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr (click)="selectResource(resource)" *ngFor="let resource of filteredResources; let i = index">
                    <td>
                      <mat-icon class="selectIcon"> keyboard_arrow_right</mat-icon>
                      <ngb-highlight [result]="resource.name" [term]="addResourceFrom.get('resourceName').value"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="resource.department" [term]="resource.department"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="resource.branchCode" [term]="resource.branchCode"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="resource.branchDescription" [term]="resource.branchDescription"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="resource.resourceDesc1" [term]="resource.resourceDesc1"> </ngb-highlight>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="group-gap row mb-4">
            <label class="resource-name-label col-md-3" for="resourceName">RESOURCE DESCRIPTION </label>
            <input class="col-md-2 ms-3" matInput placeholder="Description 1" formControlName="resourceDesc1" />
            <input class="col-md-2 ms-3" matInput placeholder="Description 2" formControlName="resourceDesc2" />
          </div>
          <div class="group-gap row mb-4">
            <div class="col-md-3">
              <label class="resource-name-label" for="resourceName">SELECT TIMEFRAME: </label>
            </div>
            <mat-radio-group aria-label="Select an option" class="col-md-8" formControlName="timeframe">
              <div class="col-md-4 mb-2">
                <mat-radio-button [value]="1">JUST CURRENT DATE </mat-radio-button>
              </div>
              <div class="col-md-4 mb-2"><mat-radio-button [value]="2">ALL CURRENT AND FUTURE DATES</mat-radio-button></div>
              <div class="col-md-4"><mat-radio-button [value]="3">DATE RANGE</mat-radio-button></div>
              <div *ngIf="showDateTimeFrame" class="row">
                <div class="col-md-4">
                  <label>FROM</label>
                </div>
                <div class="col-md-3">
                  <label>TO</label>
                </div>
                <div></div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input
                      class="form-control"
                      name="d1"
                      ngbDatepicker
                      #d1="ngbDatepicker"
                      [placement]="'bottom'"
                      container="body"
                      formControlName="startDate"
                      [readonly]="!timeframeEditable"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-secondary calendar text-white btn-picker" (click)="d1.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input
                      class="form-control"
                      name="d2"
                      ngbDatepicker
                      #d2="ngbDatepicker"
                      [placement]="'bottom'"
                      container="body"
                      formControlName="endDate"
                      [readonly]="!timeframeEditable"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-secondary calendar text-white btn-picker" (click)="d2.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
              </div>
            </mat-radio-group>
          </div>
          <div class="group-gap row mb-2">
            <div class="col-md-3">
              <label class="resource-name-label" for="resourceName">WORKING HOURS:</label>
            </div>
            <mat-radio-group aria-label="Select an option" class="col-md-8" formControlName="hours">
              <div class="col-md-4">
                <mat-radio-button [value]="1">USE STANDARD WORKSHOP HOURS </mat-radio-button>
              </div>
              <div class="col-md-4"><mat-radio-button [value]="2">USE CUSTOM WORKSHOP HOURS</mat-radio-button></div>
            </mat-radio-group>
            <div *ngIf="showHoursForm">
              <div *ngIf="showHoursForm && this.addResourceFrom.value.hours === 2">Need at least Day Start and Finish time</div>
              <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <mat-label>DAY START TIME</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="!overriddenHoursTF"
                    [class.inputDisable]="!overriddenHoursTF"
                    formControlName="startTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>DAY END TIME</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="!overriddenHoursfinishTimeTF || !overriddenHoursTF"
                    [class.inputDisable]="!overriddenHoursfinishTimeTF || !overriddenHoursTF"
                    formControlName="finishTime"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-2 bg-light">
                  <mat-label>BREAK 1 START</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break1StartTime"
                  />
                </div>
                <div class="col-md-2 bg-light">
                  <mat-label>BREAK 1 END</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break1EndTime"
                  />
                </div>
                <div class="col-md-2 bg-light">
                  <div><mat-label>BREAK 1 NAME</mat-label></div>
                  <div>
                    <input
                      matInput
                      [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                      [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                      formControlName="break1Name"
                    />
                  </div>
                </div>
                <div
                  *ngIf="
                    overriddenHoursTF &&
                    (this.addResourceFrom.value.break1StartTime || this.addResourceFrom.value.break1EndTime || this.addResourceFrom.value.break1Name)
                  "
                  class="col-md-2"
                >
                  <mat-icon (click)="clearBreakValue(1)" title="Clear">close</mat-icon>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3"></div>

                <div class="col-md-2">
                  <mat-label>BREAK 2 START</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break2StartTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>BREAK 2 END</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break2EndTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>BREAK 2 NAME</mat-label
                  ><input
                    matInput
                    [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break2Name"
                  />
                </div>
                <div
                  *ngIf="
                    overriddenHoursTF &&
                    (this.addResourceFrom.value.break2StartTime || this.addResourceFrom.value.break2EndTime || this.addResourceFrom.value.break2Name)
                  "
                  class="col-md-2"
                >
                  <mat-icon (click)="clearBreakValue(2)" title="Clear">close</mat-icon>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3"></div>

                <div class="col-md-2 bg-light">
                  <mat-label>BREAK 3 START</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break3StartTime"
                  />
                </div>
                <div class="col-md-2 bg-light">
                  <mat-label>BREAK 3 END</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break3EndTime"
                  />
                </div>
                <div class="col-md-2 bg-light">
                  <mat-label>BREAK 3 NAME</mat-label
                  ><input
                    matInput
                    [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break3Name"
                  />
                </div>
                <div
                  *ngIf="
                    overriddenHoursTF &&
                    (this.addResourceFrom.value.break3StartTime || this.addResourceFrom.value.break3EndTime || this.addResourceFrom.value.break3Name)
                  "
                  class="col-md-2"
                >
                  <mat-icon (click)="clearBreakValue(3)" title="Clear">close</mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="col d-flex float-end justify-content-end">
          <button class="btn btn-cancel mx-1 px-2" (click)="submitAddResourceFrom(false)">CANCEL</button>
          <button class="btn text-white mx-1 px-2" type="submit" [disabled]="!addResourceFrom.valid">SAVE</button>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="actionChangeResource && !actionAddResource && !actionRemoveResource && !changeDateAndTime">
    <div class="modal-header">
      <h4 class="modal-title">EDIT RESOURCES</h4>
    </div>

    <div class="edit-users mat-elevation-z8">
      <div class="table-responsive">
        <table mat-table class="full-width-table" matSort aria-label="Elements" [dataSource]="dataSource">
          <!-- Id Column -->
          <ng-container matColumnDef="resourceID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Resource ID</th>
            <td mat-cell *matCellDef="let row">{{ row.resourceID }}</td>
          </ng-container>

          <!-- First Name Column -->
          <ng-container matColumnDef="resourceName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>RESOURCE</th>
            <td mat-cell *matCellDef="let row">
              <input [formControl]="row.validator.get('resourceName')" type="text" matInput [readonly]="true" (change)="changeFn($event, row)" />
            </td>
          </ng-container>

          <!-- Last Name Column -->
          <ng-container matColumnDef="resourceDesc1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>DESCRIPTION 1</th>
            <td mat-cell *matCellDef="let row">
              <input [formControl]="row.validator.get('resourceDesc1')" type="text" matInput [readonly]="!row.editable" />
            </td>
          </ng-container>

          <!-- Username Column -->
          <ng-container matColumnDef="resourceDesc2">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>DESCRIPTION 2</th>
            <td mat-cell *matCellDef="let row">
              <input [formControl]="row.validator.get('resourceDesc2')" type="text" matInput [readonly]="!row.editable" />
            </td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>ACTION</th>
            <td mat-cell *matCellDef="let row; let i = index">
              <span style="display: flex">
                <button  mat-icon-button color="primary" focusable="false" (click)="changeTimeDate(row, i)">
                  <mat-icon matTooltip="CHANGE WORKING HOURS">schedule</mat-icon>
                </button>
                <button *ngIf="row.editable" mat-icon-button color="primary" focusable="false" (click)="confirmEditCreate(row)">
                  <mat-icon matTooltip="Save">check</mat-icon>
                </button>
                <button *ngIf="!row.editable" mat-icon-button color="primary" focusable="false" (click)="startEdit(row, i)">
                  <mat-icon matTooltip="Edit">edit</mat-icon>
                </button>
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>DELETE</th>
            <td mat-cell *matCellDef="let row; let i = index">
              <span style="display: flex">
                
                <button mat-icon-button color="warn" focusable="false" (click)="cancelOrDelete(row, i)">
                  <mat-icon [matTooltip]="row.editable ? 'Undo' : 'Delete'">{{ row.editable ? 'close' : 'delete' }}</mat-icon>
                </button>
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="row.editable ? 'editable' : 'readonly'"></tr>
        </table>
      </div>
      <!-- <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]"> </mat-paginator> -->
    </div>
    <div class="modal-footer">
      <div class="col d-flex float-end justify-content-end">
        <button class="btn btn-cancel mx-1 px-2" (click)="activeModal.close()">CANCEL</button>
        <button class="btn text-white mx-1 px-2" (click)="saveAllChanges()" [disabled]="!edited">SAVE</button>
      </div>
    </div>
  </div>

  <div *ngIf="changeDateAndTime">
    <form [formGroup]="changeDateTime" (submit)="submitChangeDateTimeForm(true)">
      <div class="modal-header">
        <h4 class="modal-title">CHANGE WORKING HOURS</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <div class="row mb-4">
            <div class="col-md-2"><label> SELECTED RESOURCE </label></div>
            <div class="col-md-4"><input [readonly]="true" [value]="selectedResource" /></div>
          </div>
          <div class="group-gap row mb-4">
            <div class="col-md-2">
              <label class="resource-name-label" for="resourceName">SELECT TIMEFRAME: </label>
            </div>
            <mat-radio-group aria-label="Select an option" class="col-md-8" formControlName="timeframe">
              <div class="col-md-4 mb-2">
                <mat-radio-button [value]="1">JUST CURRENT DATE </mat-radio-button>
              </div>
              <div class="col-md-4 mb-2"><mat-radio-button [value]="2">ALL CURRENT AND FUTURE DATES</mat-radio-button></div>
              <div class="col-md-4"><mat-radio-button [value]="3">DATE RANGE</mat-radio-button></div>
              <div *ngIf="showDateTimeFrame" class="row">
                <div class="col-md-4">
                  <label>FROM</label>
                </div>
                <div class="col-md-3">
                  <label>TO</label>
                </div>
                <div></div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input
                      class="form-control"
                      name="d1"
                      ngbDatepicker
                      #d1="ngbDatepicker"
                      [placement]="'bottom'"
                      container="body"
                      formControlName="startDate"
                      [readonly]="!timeframeEditable"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-secondary calendar text-white btn-picker" (click)="d1.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input
                      class="form-control"
                      name="d2"
                      ngbDatepicker
                      #d2="ngbDatepicker"
                      [placement]="'bottom'"
                      container="body"
                      formControlName="endDate"
                      [readonly]="!timeframeEditable"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-secondary calendar text-white btn-picker" (click)="d2.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
              </div>
            </mat-radio-group>
          </div>
          <div class="group-gap row mb-2">
            <div class="col-md-2">
              <label class="resource-name-label" for="resourceName">WORKING HOURS:</label>
            </div>
            <mat-radio-group aria-label="Select an option" class="col-md-8" formControlName="hours">
              <div class="col-md-4">
                <mat-radio-button [value]="1">USE STANDARD WORKSHOP HOURS </mat-radio-button>
              </div>
              <div class="col-md-4"><mat-radio-button [value]="2">USE CUSTOM WORKSHOP HOURS</mat-radio-button></div>
            </mat-radio-group>
            <div *ngIf="showHoursForm">
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <mat-label>DAY START TIME</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="!overriddenHoursTF"
                    [class.inputDisable]="!overriddenHoursTF"
                    formControlName="startTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>DAY END TIME</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="!overriddenHoursfinishTimeTF || !overriddenHoursTF"
                    [class.inputDisable]="!overriddenHoursfinishTimeTF || !overriddenHoursTF"
                    formControlName="finishTime"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-2">
                  <mat-label>BREAK 1 START</mat-label
                  ><input
                    matInput
                    type="time"
                    type="time"
                    [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break1StartTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>BREAK 1 END</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break1EndTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>BREAK 1 NAME</mat-label
                  ><input
                    matInput
                    [readonly]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak1 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break1Name"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-2"></div>

                <div class="col-md-2">
                  <mat-label>BREAK 2 START</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break2StartTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>BREAK 2 END</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break2EndTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>BREAK 2 NAME</mat-label
                  ><input
                    matInput
                    [readonly]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak2 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break2Name"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-2"></div>

                <div class="col-md-2">
                  <mat-label>BREAK 3 START</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break3StartTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>BREAK 3 END</mat-label
                  ><input
                    matInput
                    type="time"
                    [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break3EndTime"
                  />
                </div>
                <div class="col-md-2">
                  <mat-label>BREAK 3 NAME</mat-label
                  ><input
                    matInput
                    [readonly]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    [class.inputDisable]="disableBreak3 || !overriddenBreakTF || !overriddenHoursTF"
                    formControlName="break3Name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="col d-flex float-end justify-content-end">
          <button class="btn btn-cancel mx-1 px-2" (click)="submitForm(false)">CANCEL</button>
          <button class="btn text-white mx-1 px-2" type="submit" [disabled]="!changeDateTime.valid">SAVE</button>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="actionRemoveResource">
    <form [formGroup]="resourceRemoveform" (submit)="submitResourceRemoveform(true)">
      <div class="modal-header">
        <h4 class="modal-title">REMOVE RESOURCE</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <div class="row mb-2">
            <div class="col-md-2">
              <label>SELECT RESOURCE </label>
            </div>
            <div class="col-md-4">
              <select formControlName="resourceID" class="mb-2 pt-2 pb-2">
                <option *ngFor="let resource of resourceList; index as i" [value]="resource.resourceID" class="p-1">
                  {{ resource.resourceName }}
                </option>
              </select>
            </div>
          </div>
          <div class="group-gap row mb-4">
            <div class="col-md-2">
              <label class="resource-name-label" for="resource">SELECT TIMEFRAME: </label>
            </div>
            <mat-radio-group aria-label="Select an option" class="col-md-8" formControlName="timeframe">
              <div class="col-md-4 mb-2">
                <mat-radio-button [value]="1">JUST TODAY</mat-radio-button>
              </div>
              <div class="col-md-4 mb-2"><mat-radio-button [value]="2">TODAY AND FUTURE DATES</mat-radio-button></div>
              <div class="col-md-4"><mat-radio-button [value]="3">DATE RANGE</mat-radio-button></div>
              <div *ngIf="showDateTimeFrame" class="row">
                <div class="col-md-4">
                  <label>FROM</label>
                </div>
                <div class="col-md-3">
                  <label>TO</label>
                </div>
                <div></div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input
                      class="form-control"
                      name="d1"
                      ngbDatepicker
                      #d1="ngbDatepicker"
                      [placement]="'bottom'"
                      container="body"
                      formControlName="startDate"
                      [readonly]="!timeframeEditable"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-secondary calendar text-white btn-picker" (click)="d1.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input
                      class="form-control"
                      name="d2"
                      ngbDatepicker
                      #d2="ngbDatepicker"
                      [placement]="'bottom'"
                      container="body"
                      formControlName="endDate"
                      [readonly]="!timeframeEditable"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-secondary calendar text-white btn-picker" (click)="d2.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="col d-flex float-end justify-content-end">
          <button class="btn btn-cancel mx-1 px-2" (click)="submitResourceRemoveform(false)">CANCEL</button>
          <button class="btn text-white mx-1 px-2" type="submit" [disabled]="!resourceRemoveform.valid">DELETE</button>
        </div>
      </div>
    </form>
  </div>
</div>
